<template>
    <div class="overflow-x-auto shadow mt-4 mb-[3%]">
        <table class="w-full border-[1px] text-left lg:text-xl" id="offers_table">
            <thead class="text-white text-center" id="offers_head">
                <tr class="border-b-[1px] border-black bg-[#545656] py-2">
                    <th class="w-[5%] font-medium p-3" id="header_ID">ID</th>
                    <th class="w-[5%] font-medium p-3" id="header_Stud">#Stud</th>
                    <th class="w-[5%] font-medium p-3" id="header_Doz">#Doz</th>
                    <th class="w-[5%] font-medium p-3" id="header_Relevanz">Relevanz</th>
                    <th class="w-[5%] font-medium p-3" id="header_PDF">PDF</th>
                    <th class="w-[15%] font-medium p-3" id="header_Einrichtungskosten">
                        Einrichtungskosten
                    </th>
                    <th class="w-[10%] font-medium p-3" id="header_Lizenzgebühren">
                        Lizenzgebühren
                    </th>
                    <th class="w-[35%] font-medium p-3" id="header_Kommentar">Kommentar</th>
                    <th class="w-[15%] font-medium p-3" id="header_Oeffnen" colspan="2">Öffnen</th>
                </tr>
            </thead>
            <tbody class="text-center" id="offers_body">
                <tr class="border-b-2" v-for="offer in props.offers" v-bind:key="offer.id">
                    <td class="w-[5%] font-medium p-3" id="body_ID">{{ offer.id }}</td>
                    <td class="w-[5%] font-medium p-3" id="body_Stud">
                        {{ offer.numStudents }}
                    </td>
                    <td class="w-[5%] font-medium p-3" id="body_Doz">
                        {{ offer.numTeachers }}
                    </td>
                    <td class="w-[5%] font-medium p-3" id="body_Relevanz">
                        {{ offer.relevance }}
                    </td>
                    <td class="w-[5%] font-medium p-3" id="body_PDF" v-if="offer.path">
                        <button
                            id="pdf_button"
                            @click="() => props.pdfMethod && props.pdfMethod(offer.id, contactId)"
                        >
                            <img
                                src="@/assets/images/PDF_file_icon.svg"
                                alt="Open"
                                class="lg:w-[35px] w-[20px]"
                            />
                        </button>
                    </td>
                    <td class="w-[5%] font-medium p-3" v-else></td>
                    <td class="w-[15%] font-medium p-3" id="body_Einrichtungskosten">
                        {{ offer.set_up_price }}
                    </td>
                    <td class="w-[10%] font-medium p-3" id="body_Lizenzgebühren">
                        {{ offer.edu_swiss_total }}
                    </td>
                    <td class="w-[35%] font-medium p-3" id="body_Kommentar">
                        {{ offer.comments }}
                    </td>
                    <td class="w-[15%] font-medium p-3" id="body_Oeffnen">
                        <button
                            data-cy="select_button"
                            @click="
                                props.selectOfferMethod && props.selectOfferMethod(offer, contactId)
                            "
                        >
                            <!-- <router-link :to='"/offers/createoffer/" + $route.params.id + "/" + offer.id'> -->
                            <button>
                                <img
                                    src="@/assets/images/Arrow_right.png"
                                    alt="Open"
                                    class="lg:w-[35px] w-[20px]"
                                />
                            </button>
                            <!-- </router-link> -->
                        </button>
                        <button
                            v-if="props.hasLink && props.hasLink('offer/delete_single')"
                            id="delete_button"
                            @click="
                                () => props.deleteMethod && props.deleteMethod(contactId, offer.id)
                            "
                            class="ml-[25%]"
                        >
                            <img
                                src="@/assets/images/Trash.png"
                                alt="Del"
                                class="lg:w-[35px] w-[20px]"
                            />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
    import { useRoute } from 'vue-router'
    import { SelectedOffer } from '@/model/types'

    // Define the props with explicit types
    const props = defineProps({
        selectOfferMethod: Function,
        deleteMethod: Function,
        pdfMethod: Function,
        offers: Array as () => SelectedOffer[],
        hasLink: Function,
    })

    const route = useRoute()
    const contactId = route.params.id
</script>
